import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a03a50b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app" }

import { onUnmounted, watch, provide, ref, computed, ComputedRef } from 'vue'
import './common.less'
import NavBar from '@/components/NavBar.vue'
import provide_key from '@/constant/provide_key'
import FooterBar from './components/FooterBar.vue'

const visibleWdith = 1027

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const windowWdith = ref<number>(0)
const shrink:ComputedRef<boolean> = computed(() => windowWdith.value < visibleWdith)

const onResize = () => windowWdith.value = window.innerWidth
window.addEventListener('resize', onResize)
window.addEventListener('reset', onResize)

onUnmounted(() => window.removeEventListener('resize', onResize))

watch(() => window.innerHeight, () => windowWdith.value = window.innerWidth, {immediate: true})

provide(provide_key.SHRINK, shrink)


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavBar),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_ctx.$route.meta.keepAlive)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: _ctx.$route.name
              }))
            : _createCommentVNode("", true)
        ], 1024)),
        (!_ctx.$route.meta.keepAlive)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: _ctx.$route.name
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(FooterBar)
  ]))
}
}

})